import { createAsyncAction, createSyncAction } from "../utils/actionCreators";

export const types = {
  LOGIN: "@@auth/LOGIN",
  LOGOUT: "@@auth/LOGOUT",
  ESQUECI_SENHA: "@@auth/ESQUECI_SENHA",
  TROCAR_SENHA: "@@auth/TROCAR_SENHA",
  VALIDAR_TOKEN_SENHA: "@@auth/VALIDAR_TOKEN_SENHA",
  TOKEN_LOGIN: "@@auth/TOKEN_LOGIN",
  REENVIAR_TOKEN_SENHA: "@@auth/REENVIAR_TOKEN_SENHA",
};

export const actions = {
  login: createAsyncAction(types.LOGIN),
  logout: () => createSyncAction(types.LOGOUT),
  esqueciSenha: createAsyncAction(types.ESQUECI_SENHA),
  trocarSenha: createAsyncAction(types.TROCAR_SENHA),
  validarTokenSenha: createAsyncAction(types.VALIDAR_TOKEN_SENHA),
  tokenLogin: createAsyncAction(types.TOKEN_LOGIN),
  reenviarTokenSenha: createAsyncAction(types.REENVIAR_TOKEN_SENHA),
};
